export default "__VITE_ASSET__3mmVwhdb__"